import React from "react";
import { Helmet } from "react-helmet-async";
import { BIZ, SITE_TITLE_SUFFIX } from "@/data/site";

/**
 * Per-page <head> tags: title, description, canonical, OG/Twitter, JSON-LD.
 */
export default function Seo({
  title,
  description,
  path = "/",
  noIndex = false,
  jsonLd,
  ogImage,
}) {
  const url = `${BIZ.siteUrl}${path}`;
  const finalTitle = title ? `${title}${SITE_TITLE_SUFFIX}` : `${BIZ.name} — Pressure Washing & Soft Washing in ${BIZ.city}, ${BIZ.stateShort}`;
  const img = ogImage || `${BIZ.siteUrl}${BIZ.logo}`;
  return (
    <Helmet>
      <title>{finalTitle}</title>
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={url} />
      {noIndex && <meta name="robots" content="noindex,nofollow" />}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={BIZ.name} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={finalTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:image" content={img} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={finalTitle} />
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={img} />
      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      )}
    </Helmet>
  );
}
